import { NgModule, ModuleWithProviders } from '@angular/core';
import { DndModule } from 'ngx-drag-drop';
import { NgxMasonryModule } from 'ngx-masonry';

import {FieldsModule} from '../fields/fields.module';
import {SharedModule} from '../shared/shared.module';

import {AutosizeInputDirective} from '../shared/autosize-input.directive';

import {SlideshowService, TakeoverDialog, AutosaveDialog, SendToEditorDialog, 
    DeleteDialog, PublishDialog, CopyDialog, CannotViewDialog, SetStatusDialog} from './slideshow.service';
import {SlideshowComponent, SitesPipe, GoBackDialog, CommentDialog} from './slideshow.component';

import {ImageDetailsComponent} from './images/image-details.component';
import {ImageDetailsDialog} from './images/image-details-dialog.component';
import {CropperComponent} from './images/cropper.component';
import {GettyComponent, EditImageDialog} from './images/getty.component';

import {ImageComponent, TempImagesPipe} from './slide/parts/image.component';
import {SlideComponent} from './slide/slide.component';

import {SlidesComponent, TeaserDialog} from './slides/slides.component';

import {WritingComponent} from './tabs/writing.component';
import {DetailsComponent} from './tabs/details.component';
import {ImagesComponent, SearchImagesPipe} from './tabs/images.component';
import {PreviewComponent} from './tabs/preview.component';
import {PreviewContentComponent} from './tabs/preview/content.component';
import {PreviewContentQuizComponent} from './tabs/preview/content-quiz.component';
import {PreviewImageQuizComponent} from './tabs/preview/parts/image-quiz.component';
import {PreviewQuestionComponent} from './tabs/preview/parts/question.component';
import {PreviewQuizIntroComponent} from './tabs/preview/parts/intro-quiz.component';
import {PreviewResultsComponent} from './tabs/preview/parts/results.component';
import {MetaComponent, TaxFilterPipe, RemoveTaxonomyDialog} from './tabs/meta.component';

@NgModule({
    declarations: [ 
        AutosizeInputDirective,
        SlideshowComponent,
        GoBackDialog,
        CommentDialog,
        // images
        ImageDetailsComponent,
        CropperComponent,
        GettyComponent,
        EditImageDialog,
        // parts
        ImageComponent,
        ImageDetailsDialog,
        // slide
        SlideComponent,
        //slides
        SlidesComponent,
        TeaserDialog,
        //tabs
        DetailsComponent,
        ImagesComponent,
        PreviewComponent,
        PreviewContentComponent,
        PreviewContentQuizComponent,
        PreviewImageQuizComponent,
        PreviewQuestionComponent,
        PreviewQuizIntroComponent,
        PreviewResultsComponent,
        MetaComponent,
        WritingComponent,
        SendToEditorDialog,
        //takeover
        TakeoverDialog,
        AutosaveDialog,
        DeleteDialog,
        PublishDialog,
        CopyDialog,
        CannotViewDialog,
        SetStatusDialog,
        RemoveTaxonomyDialog,
        //pipes
        SitesPipe,
        TempImagesPipe,
        SearchImagesPipe,
        TaxFilterPipe
    ],
    entryComponents: [
        TeaserDialog,
        SendToEditorDialog,
        TakeoverDialog,
        AutosaveDialog,
        DeleteDialog,
        PublishDialog,
        GoBackDialog,
        CommentDialog,
        ImageDetailsDialog,
        CopyDialog,
        CannotViewDialog,
        SetStatusDialog,
        EditImageDialog,
        RemoveTaxonomyDialog
    ],
    imports: [
        FieldsModule,
        SharedModule,
        DndModule,
        NgxMasonryModule
    ],
    exports: [
        TempImagesPipe,
        AutosizeInputDirective
    ]
})
export class SlideshowModule { 
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SlideshowModule,
            providers: [SlideshowService]
        }
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/slideshow.module.ts